module.exports = __webpack_public_path__ + "img/centurion-living.7efb9234.jpg";